import React, { createContext, useState, useContext } from 'react';

// 1. สร้างพจนานุกรมคำศัพท์ (Dictionary)
const dictionary = {
  en: {
    welcome: "Welcome to React",
    button_label: "Change to Thai"
  },
  th: {
    welcome: "ยินดีต้อนรับสู่ React",
    button_label: "เปลี่ยนเป็นภาษาอังกฤษ"
  }
};

// 2. สร้าง Context (ตัวกระจายสัญญาณ)
const LanguageContext = createContext();

// 3. สร้าง Provider (ตัวจัดการเปลี่ยนภาษา)
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("en"); // เริ่มต้นที่ภาษาอังกฤษ

  // ฟังก์ชันสลับภาษา
  const toggleLanguage = () => {
    setLanguage((prev) => (prev === "en" ? "th" : "en"));
  };

  // ข้อมูลที่จะส่งให้ทุกหน้าจอ (ภาษาปัจจุบัน, คำศัพท์ของภาษานั้น, ฟังก์ชันเปลี่ยนภาษา)
  const value = {
    language,
    text: dictionary[language],
    toggleLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

// 4. สร้าง Hook ไว้เรียกใช้ง่ายๆ
export const useLanguage = () => useContext(LanguageContext);